(function () {
  function formatMoney(cents) {
    return '$' + ((cents || 0) / 100).toFixed(2);
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function escapeAttr(str) {
    return String(str || '').replace(/"/g, '&quot;');
  }

  var drawer;
  var drawerBody;
  var delegationBound = false;

  function getDrawer() {
    drawer = document.querySelector('[data-cart-drawer]');
    drawerBody = drawer ? drawer.querySelector('[data-cart-drawer-body]') : null;
    return !!(drawer && drawerBody);
  }

  function updateCartCountDisplay(count) {
    document.querySelectorAll('[data-cart-count], .cart-count-bubble, .header__cart-count').forEach(function (el) {
      el.textContent = count;
    });
  }

  function bindDelegation() {
    if (delegationBound || !drawerBody) return;
    delegationBound = true;
    drawerBody.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-remove]');
      if (!btn) return;
      var lineKey = btn.getAttribute('data-line-key');
      if (lineKey) changeCartLine(lineKey, 0);
    });
    drawerBody.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty-input]');
      if (!input) return;
      var lineKey = input.getAttribute('data-line-key');
      var quantity = Math.max(0, Number(input.value || 0));
      if (lineKey) changeCartLine(lineKey, quantity);
    });
  }

  function renderCartDrawer(cart) {
    if (!getDrawer()) return;
    bindDelegation();

    updateCartCountDisplay(cart.item_count);

    drawer.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
    });

    var countLabel = drawer.querySelector('.cart-drawer__count');
    if (countLabel) {
      countLabel.innerHTML =
        '<span data-cart-count>' +
        cart.item_count +
        '</span> item(s)';
    }

    if (!cart.items.length) {
      drawerBody.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<div class="cart-drawer__empty-icon" aria-hidden="true">🛒</div>' +
        '<p class="cart-drawer__empty-title">Your cart is empty</p>' +
        '<p class="cart-drawer__empty-copy">Browse the shop and add something you love.</p>' +
        '</div>';
      return;
    }

    drawerBody.innerHTML =
      '<div class="cart-drawer__items">' +
      cart.items
        .map(function (item) {
          var imageMarkup = item.image
            ? '<a href="' +
              escapeAttr(item.url) +
              '" class="cart-drawer__item-image"><img src="' +
              escapeAttr(item.image) +
              '" alt="' +
              escapeHtml(item.product_title) +
              '" width="120" height="120" loading="lazy"></a>'
            : '';

          var variantMarkup =
            item.variant_title && item.variant_title !== 'Default Title'
              ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
              : '';

          return (
            '<article class="cart-drawer__item" data-line-item data-line-key="' +
            escapeAttr(item.key) +
            '">' +
            imageMarkup +
            '<div class="cart-drawer__item-details"><a href="' +
            escapeAttr(item.url) +
            '" class="cart-drawer__item-title">' +
            escapeHtml(item.product_title) +
            '</a>' +
            variantMarkup +
            '<p class="cart-drawer__item-price">' +
            formatMoney(item.final_price) +
            '</p>' +
            '<div class="cart-drawer__item-actions">' +
            '<label class="cart-drawer__qty-label" for="DrawerQty-' +
            escapeAttr(item.key) +
            '">Qty</label>' +
            '<input id="DrawerQty-' +
            escapeAttr(item.key) +
            '" class="cart-drawer__qty" type="number" min="0" value="' +
            item.quantity +
            '" data-cart-qty-input data-line-key="' +
            escapeAttr(item.key) +
            '" />' +
            '<button type="button" class="cart-drawer__remove" data-cart-remove data-line-key="' +
            escapeAttr(item.key) +
            '">Remove</button>' +
            '</div></div>' +
            '<div class="cart-drawer__item-total">' +
            formatMoney(item.final_line_price) +
            '</div></article>'
          );
        })
        .join('') +
      '</div>';
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        renderCartDrawer(cart);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (err) {
        console.warn('Could not refresh cart drawer.', err);
      });
  }

  function open() {
    if (!getDrawer()) return;
    drawer.hidden = false;
    document.body.classList.add('cart-drawer-open');
  }

  function close() {
    if (!getDrawer()) return;
    drawer.hidden = true;
    document.body.classList.remove('cart-drawer-open');
  }

  function refreshThenOpen() {
    return refresh().then(function () {
      open();
    });
  }

  function changeCartLine(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function () {
        return refresh();
      })
      .catch(function (e) {
        console.warn('Could not update cart line.', e);
      });
  }

  window.MeyerCartDrawer = {
    formatMoney: formatMoney,
    escapeHtml: escapeHtml,
    refresh: refresh,
    open: open,
    close: close,
    refreshThenOpen: refreshThenOpen
  };

  document.addEventListener('DOMContentLoaded', function () {
    getDrawer();
    bindDelegation();

    document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        refreshThenOpen();
      });
    });

    document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        close();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && !drawer.hidden) {
        close();
      }
    });
  });
})();
